<script>
    // @ts-nocheck
    import Fa from 'svelte-fa';
    import { faSearch, faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

    import { onNavigate, pushState } from '$app/navigation';
    import { browser } from '$app/environment';

    import Picture from '$lib/components/Picture.svelte';

    export let searchModalOpen;

    let searchQuery = '';
    const defaultData = {
        predictiveSearch: {
            products: [],
            queries: [],
            articles: [],
            pages: [],
            collections: []
        }
    };
    let data = defaultData;

    // fetch predictive search results
    const performSearch = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.target.form.submit();
        } else if (searchQuery.trim() === '') {
            data = defaultData;
        } else {
            fetch(`/api/search/predictive?query=${searchQuery}`)
                .then((r) => r.json())
                .then((results) => {
                    data = results;
                })
                .catch((e) => console.error(e));
        }
    };

    // autofocus input on mobile modal open
    let searchInput;
    $: if (searchModalOpen === true) {
        if (searchInput) {
            setTimeout(function () {
                searchInput.focus();
            }, 1);
        }
    }

    // history state for search modal open/closed history.back();
    $: if (searchModalOpen) {
        if (browser) {
            pushState('', { searchModalOpen: true });
            addEventListener('popstate', () => {}); // TODO: Move to layout hydration probably dont need to have multi listeners
            onpopstate = () => {
                if (searchModalOpen) {
                    searchModalOpen = false;
                }
            };
        }
    }

    onNavigate(() => {
        searchQuery = '';
        searchModalOpen = false;
    });
</script>

{#if searchModalOpen}
    <div
        class={`fixed left-0 top-0 z-40 h-screen w-full bg-color-background p-4 dark:bg-base-800 lg:relative lg:z-auto lg:h-auto lg:rounded-xl lg:p-0 
           ${searchModalOpen ? 'block' : 'hidden'}`}
    >
        <form class="relative flex items-center" action="/search?query={searchQuery}" method="get" role="search">
            <button class="absolute left-4 lg:hidden" on:click={() => history.back()} aria-label="Close" type="button">
                <Fa icon={faArrowLeft} class="block text-xl" />
            </button>
            <input
                class="w-full grow rounded-xl border-none bg-white px-10 py-3.5 lowercase text-color-text shadow-md outline-none focus:ring-0 dark:bg-base-700 lg:px-4 lg:py-2"
                on:keyup={performSearch}
                bind:value={searchQuery}
                bind:this={searchInput}
                type="search"
                name="query"
                placeholder="Search products, brands, flavours"
                aria-label="Search"
                autocomplete="off"
            />
            <button
                type="submit"
                class="absolute right-4 flex items-center justify-center lg:right-3"
                aria-label="Submit Search"
                on:click={(e) => {
                    const a = e;
                    a.key = 'enter';
                    performSearch(a);
                }}
            >
                <Fa icon={faSearch} class="block text-xl" />
            </button>
        </form>

        {#if searchQuery.trim() !== ''}
            <div class="mt-2 w-full lg:absolute lg:rounded-xl lg:bg-color-background lg:p-3 lg:dark:bg-base-800">
                {#if data?.predictiveSearch?.queries.length}
                    {#each data?.predictiveSearch?.queries as query (query)}
                        <a
                            href="/search?query={query.text.toLowerCase()}"
                            class="mb-2 block w-full rounded-lg bg-base-900 px-4 py-3 text-color-text shadow-md lg:py-2"
                        >
                            <Fa icon={faSearch} class="mr-2 inline-block text-xs" />
                            {query.text.toLowerCase()}
                        </a>
                    {/each}
                {:else}
                    <a
                        href="/search?query={searchQuery.toLowerCase()}"
                        class="mb-2 block w-full rounded-lg bg-base-900 px-4 py-3 text-color-text shadow-md lg:py-2"
                    >
                        <Fa icon={faSearch} class="mr-2 inline-block text-xs" />
                        {searchQuery.toLowerCase()}
                    </a>
                {/if}

                {#if data?.predictiveSearch?.products.length}
                    {#each data?.predictiveSearch?.products.filter((product) => product.productType !== 'Discontinued') as product (product)}
                        <a href="/products/{product?.handle}" title="{product?.vendor} {product?.title}">
                            <div class="mb-2 rounded-lg bg-base-900 p-2 text-color-text shadow-md">
                                <div class="grid grid-cols-12 items-center gap-2">
                                    <div class="col-span-2">
                                        <Picture
                                            src={product?.featuredImage?.url}
                                            alt="{product?.vendor} {product?.title}"
                                            width="50"
                                            height="50"
                                            imageSizes={[50, 50, 50]}
                                            lazy={false}
                                            classes="max-w-full rounded-xl"
                                        />
                                    </div>
                                    <div class="col-span-10">
                                        <h3 class="lg:text-md text-sm font-medium dark:text-purple-300">{product?.title}</h3>
                                        <span class="block text-xs">By {product?.vendor}</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    {/each}
                {/if}
            </div>
        {/if}
    </div>

    <style>
        @media only screen and (max-width: 728px) {
            body {
                overflow: hidden !important;
            }
        }
    </style>
{/if}
